function setDescription() {
  const wrappers = document.querySelectorAll('.show-more-wrapper');
  if (!wrappers.length) return;

  wrappers.forEach(wrapper => {
    const moreBtn = wrapper.querySelector('.show-more-btn');
    const lessBtn = wrapper.querySelector('.show-less-btn');
    const firstSection = wrapper.querySelector('.show-more-first');
    const lastSection = wrapper.querySelector('.show-more-last');

    if (moreBtn) {
      moreBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (firstSection) firstSection.classList.add('currently-hidden');
        if (lastSection) lastSection.classList.remove('currently-hidden');
      });
    }

    if (lessBtn) {
      lessBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (firstSection) firstSection.classList.remove('currently-hidden');
        if (lastSection) lastSection.classList.add('currently-hidden');
      });
    }
  });
}

// Accessibility: remove empty/malformed lists from truncated HTML
function removeEmptyLists() {
  var lists = document.querySelectorAll('.show-more-text ul, .show-more-first ul, .toc-description-content ul');
  lists.forEach(function(ul) {
    var validItems = ul.querySelectorAll('li');
    var hasContent = false;
    validItems.forEach(function(li) {
      if (li.textContent.trim().length > 0) hasContent = true;
    });
    if (!hasContent) ul.remove();
  });
}

// Use DOMContentLoaded or defer attribute in script tag
document.addEventListener("DOMContentLoaded", function() {
  setDescription();
  removeEmptyLists();
  setTimeout(removeEmptyLists, 100);
  setTimeout(removeEmptyLists, 500);
  setTimeout(removeEmptyLists, 1000);
});